module.exports = __webpack_public_path__ + "img/bg-5.742377bd.png";